import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation() {
  // フッター TOPスクロールボタン
  // 最初に要素を非表示に設定
  document.getElementById("js-scrollTop").style.display = 'none';

  // スクロールイベントリスナーを追加
  window.addEventListener('scroll', function () {
    // 現在のスクロール位置を取得
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // スクロール位置が500pxを超えたら表示、それ以下なら非表示
    if (scrollPosition > 500) {
      document.getElementById("js-scrollTop").style.display = 'block';
    } else {
      document.getElementById("js-scrollTop").style.display = 'none';
    }
  });

  // 既存のクリックイベントリスナー（アニメーションのための）
  document.getElementById("js-scrollTop").addEventListener("click", () => {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: 0,
        autoKill: false
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    // .js-links-trigger 要素の存在をチェック
    const triggerElementExists = document.querySelector('.js-links-trigger');
    const triggerSettings = triggerElementExists
      ? {
        trigger: ".js-links-trigger",
        start: "top bottom",
        end: "bottom top",
      }
      : {
        trigger: document.body,
        start: "700px bottom",
        end: "bottom top",
      };

    gsap.fromTo(
      ".js-links",
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          ...triggerSettings,
          toggleActions: "play none none reverse",
          onEnter: () => {
            document.querySelector(".js-links").style.position = 'fixed';
            document.querySelector(".js-links").style.bottom = '0';
            document.querySelector(".js-links").style.width = '100%';
          },
          onLeaveBack: () => {
            document.querySelector(".js-links").style.position = 'static';
          },
          // markers: true, // 開発中の調整用
        },
      }
    );
  });



  // フェードインアニメーション
  const fadeInElements = document.querySelectorAll(".js-fade-in");
  fadeInElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 70,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power4.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 80%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInLeftElements = document.querySelectorAll(".js-fade-in-left");
  fadeInLeftElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        x: -30,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 80%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInRightElements = document.querySelectorAll(".js-fade-in-right");
  fadeInRightElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        x: 30,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 70%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });
}
